// extracted by mini-css-extract-plugin
export default {"host":"style_host__6snMv","report":"style_report__w4uqF","add":"style_add__20iWy"};